import { useAtomValue } from 'jotai';
import { Stack } from '@mui/material';
import { KpiPeriod } from '../../../../../data-models/company-financials.data-model';
import { companyStateJ } from '../../../../../services/state/CompanyStateJ';
import { FyeChip } from '../../../components/Financials/components/FyeChip';
import { FiscalDatePicker } from '../../../components/FinancialsDatePickers/FiscalDatePicker';
import { selectedCompanyIdProfileAtom } from '../../../state/UIStateJ';

export const monthsInPeriod = {
  [KpiPeriod.month]: 1,
  [KpiPeriod.quarter]: 3,
  [KpiPeriod.year]: 12,
};

export function DateSettings2() {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const fye = useAtomValue(companyStateJ(companyId))?.fye ?? 12;
  return (
    <Stack direction='row' justifyContent={'space-between'} alignItems={'center'} mt='1rem' mb='-1rem'>
      <FiscalDatePicker fye={fye} />
      <FyeChip fye={fye} />
    </Stack>
  );
}
